export const AI_TOOLS_ONBOARDING_TARGETS = {
  exploreTools: "explore-ai-tools-joyride",
  accessHistory: "access-history-joyride",
  takeALook: "take-a-look-joyride",
  describeActivity: "describe-activity-joyride",
  generateActivity: "generate-activity-joyride",
}

export enum OnboardingPhase {
  intro = "intro",
  joyride = "joyride",
}

export enum AIToolsOnboardingStep {
  exploreTools = "exploreTools",
  accessHistory = "accessHistory",
  takeALook = "takeALook",
  describeActivity = "describeActivity",
  generateActivity = "generateActivity",
}

export const ORDERED_STEPS: AIToolsOnboardingStep[] = [
  AIToolsOnboardingStep.exploreTools,
  AIToolsOnboardingStep.accessHistory,
  AIToolsOnboardingStep.takeALook,
  AIToolsOnboardingStep.describeActivity,
  AIToolsOnboardingStep.generateActivity,
]

export const STEP_QUERY_KEY = "ai-tools-onboarding-step"
